<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>队列设置</h4>
    </div> -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <div style="margin:10px 0 0 10px;">
            <el-form-item>
              <el-button type="primary" @click="searchFn" btnCode="01K0040100" v-if="btnFlg[0]">查询</el-button>
              <el-button type="primary" @click="resetForm" btnCode="01K0040200"
                v-if="btnFlg[1]">重置</el-button>
              <el-button type="primary" @click="tianjia" btnCode="01K0040300" v-if="btnFlg[2]">新增</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
        <el-table :data="tableList" ref="table" bordersize="mini" @selection-change='selectGoods' style="width: 100%"
            height="100%" center border class="tableComent">
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column prop="province" label="操作" align="center" width="100">
                <template slot-scope="scope">
                    <!-- 1显示通过/驳回 ，不是1显示记录 -->
                    <div>
                        <el-button type="text" @click="xiugai(scope.row)" btnCode="01K0040400"
                            v-if="btnFlg[3]">修改</el-button>
                        <el-button type="text" @click="shanchu(scope.row)" btnCode="01K0040500"
                            v-if="btnFlg[4]">删除</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column property="queueName" width="180" label="队列名称"></el-table-column>
            <el-table-column property="jobType" width="100" label="作业类型"></el-table-column>
            <el-table-column property="productTypeName" width="120" :formatter="emptyFn" label="货物类型">
            </el-table-column>
            <el-table-column property="jobLocationCapacity" :formatter="emptyFn" width="120"
                label="仓内作业位容量"></el-table-column>
            <el-table-column property="availableLocationCapacity" :formatter="emptyFn" width="120"
                label="可用作业位容量"></el-table-column>
            <el-table-column property="numberPrefix" width="120" :formatter="emptyFn" label="序号前缀"></el-table-column>
            <el-table-column property="numberLength" width="100" :formatter="emptyFn" label="序号长度"></el-table-column>
            <el-table-column property="remark"  :formatter="emptyFn" label="备注"></el-table-column>
            <el-table-column property="createUser" width="120" :formatter="emptyFn" label="创建人"></el-table-column>
            <el-table-column property="createTime" width="160" :formatter="dateTimeFormat"
                label="创建时间"></el-table-column>

        </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[10, 20, 30, 40, 50]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog :title="title" @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false"
        :visible.sync="addMark" width="40%" center>
        <div style="width:55%; margin:15px auto;">
            <span>
                <el-form :model="addFrom" :rules="rules" ref="addFrom" class="demo-form-inline" label-width="130px"
                    size="mini">
                    <el-form-item label="队列名称:" prop="queueName">
                        <el-input placeholder="请输入队列名称" maxlength="20" v-model="addFrom.queueName"
                            style="width:190px;"></el-input>
                    </el-form-item>
                    <el-form-item label="作业类型:" prop="jobType" style="margin-top:20px;">
                        <el-radio v-model="addFrom.jobType" label="装货">装货</el-radio>
                        <el-radio v-model="addFrom.jobType" label="卸货">卸货</el-radio>
                    </el-form-item>
                    <el-form-item label="货物类型：" prop="productTypeName">
                        <el-select v-model="addFrom.productTypeName" placeholder="请选择" style="width:190px;">
                            <el-option v-for="item in typeList" :key="item.itemNo" :label="item.showName"
                                :value="item.showName">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="仓内作业位容量:" prop="jobLocationCapacity">
                        <el-input placeholder="请输入仓内作业位容量" maxlength="10" v-model.number="addFrom.jobLocationCapacity"
                            style="width:190px;"></el-input>
                    </el-form-item>
                    <el-form-item label="序号前缀:" prop="numberPrefix">
                        <el-input placeholder="请输入序号前缀" onKeyUp="value=value.replace(/[\W]/g,'')" maxlength="10"
                            v-model="addFrom.numberPrefix" style="width:190px;"></el-input>
                    </el-form-item>
                    <el-form-item label="序号长度:" prop="numberLength">
                        <el-input placeholder="请输入序号长度" maxlength="6" v-model.number="addFrom.numberLength"
                            style="width:190px;"></el-input>
                    </el-form-item>
                    <el-form-item label="备注:" >
                        <el-input placeholder="请输入备注" maxlength="100" v-model="addFrom.remark"
                            style="width:190px;"></el-input>
                    </el-form-item>

                </el-form>
            </span>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="tianjiaOK('addFrom')">确 定</el-button>
            <el-button @click="addMark = false">取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'

import { queueSettingsList, queueSettinsAdd, getDictionaryList, queueSettingsUpdate, queueSettingsDelete } from '@/api/lj'
export default {

  data () {
    return {
      h: 500,
      title: '',
      addMark: false,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      typeList: [],
      selctList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      loading: 'false',
      // 记录
      addFrom: { jobType: '装货' },
      carList: [],
      ssdw: [],
      vehicleSS: [
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      imgList: [],
      rules: {
        queueName: [
          { required: true, message: '请输入队列名称', trigger: 'blur' }
        ],
        jobLocationCapacity: [
          { required: true, message: '请输入作业位容量', trigger: 'blur' }
        ],
        availableLocationCapacity: [
          { required: true, message: '请输入可用作业位容量', trigger: 'blur' }
        ],
        numberPrefix: [
          { required: true, message: '请输入序号前缀', trigger: 'blur' }

        ],
        numberLength: [
          { required: true, message: '请输入序号长度', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ],
        jobType: [
          { required: true, message: '请选择作业类型', trigger: ['blur', 'change'] }
        ],
        productTypeName: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        vehicleTenantName: [
          { required: true, message: '请输入车辆所有人', trigger: 'blur' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['01K0040100', '01K0040200', '01K0040300', '01K0040400', '01K0040500']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/queueSettings')
    this.getList()
    getDictionaryList({ groupNo: 'product_type' }).then(res => {
      this.typeList = res
    }).catch(err => {
      DonMessage.error(err.message)
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 165) + 'px'
  },
  methods: {
    shanchu (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          queueSettingsDelete({
            id: row.id
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.getList(this.searchFrom)
              loading.close()
            })
            .catch((err) => {
              loading.close()

              DonMessage.error(err.message)
            })
        })
        .catch(() => { })
    },
    // 添加
    tianjia () {
      this.addFrom = {}

      this.$set(this.addFrom, 'jobType', '装货')
      // this.$set(this.addFrom, 'productTypeName', '中板')
      this.addMark = true
      this.title = '添加'
    },
    tianjiaOK (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.title == '添加') {
            queueSettinsAdd(this.addFrom).then(res => {
              this.addMark = false

              this.getList(this.searchFrom)
              loading.close()
            }).catch(err => {
              loading.close()
              DonMessage.error(err.message)
            })
          } else {
            queueSettingsUpdate(this.addFrom).then(res => {
              this.addMark = false

              this.getList(this.searchFrom)
              loading.close()
            }).catch(err => {
              loading.close()
              DonMessage.error(err.message)
            })
          }
          // this.changeLoading = true
        } else {
          return false
        }
      })
    },
    // 修改
    xiugai (row) {
      this.addMark = true
      this.title = '修改'
      this.addFrom = { ...row }
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.selctList = selection
    },
    // 获取列表
    getList () {
      queueSettingsList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        platformStatuss: [2004, 2005],
        noWayType: 3,
        settlementMethod: 1
      }
      this.getList()
    },

    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
    margin-left: 10px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 18px;
}

.inpBox .el-date-editor {
    width: 350px !important;
}
</style>
